module.exports = __webpack_public_path__ + "img/image6.801527ae.jpg";